<template>
    <!-- <div class="job-board-entry"> -->
    <div :class="['job-board-entry', {expired: expired }]">
        <div class="job-board-entry-main">
            <div class="job-board-entry-logo">
                <div v-if="logo" ><img :src="logo"></div>
            </div>
            <div class="job-board-entry-content">
                <h3>{{company}}</h3>
                <h2>{{title}}</h2>
                <div class="details">
                    <div v-if="city && state" class="location-attribute">{{city}}, {{state}}</div> 
                    <div class="pill employ" v-for="(t, index) in type" :key="index">
                        <div>{{t}}</div> 
                    </div>
                    <div v-if="remote" class="pill remote">Remote</div> 
                </div>
            </div>
        </div>
        <div class="job-board-entry-links" v-if="!expired">
            <Btn route :to="viewJobLink(uid)">View Job</Btn>
            <Btn route :to="editJobLink(uid)">Edit Job</Btn>
        </div>
    </div>
</template>

<script>
import Btn from '@/components/Btn.vue'
import { kebabCase } from '../helpers/util'
import { format } from 'date-fns'

export default {
    name: 'JobBoardListItemPrivate',
    components: {
        Btn
    },
    props: [ "uid", "logo", "title", "company", "city", "state", "type", "tags", "expires", "created", "remote" ],
    methods: {
        testDate: date => date == undefined || Date.now() > date,
        link: (id, title) => '/' + id + '/' + kebabCase( title ),
        viewJobLink:  id => '/?id=' + id,
        editJobLink: id =>'/dashboard/edit/' + id,
        formatDate: d => d === undefined ? '' : format(d, 'M/d/yyyy')
    },
    computed : {
        expired () {
            return this.testDate(this.expires)
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "../scss/vars";
    @import "../scss/pill";

    .job-board-entry{
        background-color: white;
        border-radius: $radius;
        margin-bottom: 0.5rem;
        transition: all $speed ease;
        left: 0;
        position: relative;
        // display: block;
        display: flex;
        flex-direction: column;
        @media screen and (min-width: $b1){
            flex-direction: row;
        }
        justify-content: space-between;
        text-decoration: none;
        color: $mid-gray;
        line-height: 1;
        &.expired {
            background-color: #f9f9f9;
            color: $pale-gray;
            h2, h3 {
                color: $pale-gray;
            }
            .pill {
                background-color: white;
                color: $pale-gray;
            }

        }
        // &:hover{
        //     box-shadow: 0 0.25rem 0.5rem rgba( 0, 0, 0, 0.3 );
        //     z-index: 5;
        //     position: relative;
        // }
        &-main {
            display: flex;
            flex-basis: 100%;
            flex-grow: 1;
        }
        &-logo{
            background-color: #eee;
            margin: 1rem;
            flex-basis: 6rem;
            height: 6rem;
            flex-grow: 0;
            flex-shrink: 0;
        }

        &-content{
            flex-grow: 1;
            margin: 1rem 1rem 1rem 0;
            font-size: 1.4rem;

            h3{
                font-weight: 700;
                font-size: 1.4rem;
                color: $mid-gray;
                margin: 0;
            }
            h2{
                color: $dark-blue;
                font-weight: 700;
                margin: 0.2rem 0 0 0;
                padding: 0.4rem 0;
                font-size: 1.8rem;
            }
        }
        &-attributes{
            display: flex;
            flex-wrap: wrap;

            div{
                font-size: 1rem;
                margin-right: 0.25rem;
                margin-top: 0.5rem;
            }
        }
        &-links{
            // margin: 1rem;
            padding: 0 0 1rem 0;
            display: flex;
            // padding-left: 1rem;
            flex-direction: row;
            margin-left: 8rem;
            align-items: flex-start;
            @media screen and (min-width: $b1){
                margin: 1rem;
                justify-content: center;
                align-items: center;
                padding: 0 1rem 0 0;
            }
            div {
                margin-right: 0.5rem;
                &:last-child {
                    margin-right: 0;
                }
            }
            // justify-content: center;
            // border-left: 1px solid $pale-gray;

            // .btn{
            //     display: block;
            //     margin-bottom: 0.5rem;

            //     &:last-child{
            //         margin: 0;
            //     }
            // }
        }
    }
    // .tags {
    //     display: block;
    //     margin-top: 0.4rem;
    //     > div {
    //         margin: 0.2em 0.2rem 0 0;
    //     }
    // }
    .details {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        font-size: 1.4rem;
        // margin-top: 0.2rem;
        > div {
            margin-right: 0.5rem;
        }
    }
</style>